import PropTypes from 'prop-types'

const ArrowLeft = ({ fill = '#1A1A1A' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M3.39995 8.588H14.575C14.8583 8.588 15.0958 8.49217 15.2875 8.3005C15.4791 8.10883 15.575 7.87133 15.575 7.588C15.575 7.30467 15.4791 7.06717 15.2875 6.8755C15.0958 6.68383 14.8583 6.588 14.575 6.588H3.39995L8.29995 1.688C8.49995 1.488 8.59578 1.25467 8.58745 0.988C8.57912 0.721333 8.47495 0.488 8.27495 0.288C8.07495 0.104667 7.84162 0.00883333 7.57495 0.0005C7.30828 -0.00783333 7.07495 0.088 6.87495 0.288L0.274951 6.888C0.174951 6.988 0.104118 7.09633 0.0624509 7.213C0.0207843 7.32967 -4.90602e-05 7.45467 -4.90602e-05 7.588C-4.90602e-05 7.72133 0.0207843 7.84633 0.0624509 7.963C0.104118 8.07967 0.174951 8.188 0.274951 8.288L6.87495 14.888C7.05828 15.0713 7.28745 15.163 7.56245 15.163C7.83745 15.163 8.07495 15.0713 8.27495 14.888C8.47495 14.688 8.57495 14.4505 8.57495 14.1755C8.57495 13.9005 8.47495 13.663 8.27495 13.463L3.39995 8.588Z'
        fill={fill}
      />
    </svg>
  )
}

ArrowLeft.propTypes = {
  fill: PropTypes.string,
}

export default ArrowLeft
